export const config = {
	title: "Configuraciones de tienda delivery",
	updatingData: "Actualizando datos",
	savedData: "Datos guardados",
	newImageSaved: "Nueva imagen guardada",
	form: {
		initialInfo: "información inicial",
		addressInfo: "información de dirección",
		deliveryInfo: "información de entrega",
		webpageInfo: "información de visualización",
		paymentMethods: "métodos de pago",
		additionalFields: "campos adicionales",
		qrCodesGenerate: "Generar QR Codes",
	},
	subForms: {
		additionalFields: {
			empty: "No existen campos registrados",
			add: "Agregar nuevo campo",
			label: "Leyenda",
			slug: "Slug",
			required: "Obligatorio",
			type: {
				label: "Tipo",
				text: "Alfanumérico",
				number: "Número",
				date: "Fecha",
				select: {
					label: "Opción múltiple",
					a: "Opción A",
					b: "Opción B",
					c: "Opción C",
				},
				remove: "Eliminar",
				options: {
					label: "Opciones",
					placeholder: "Agregue una nueva opción",
				},
			},
			save: "Guardar campos adicionales",
		},
		address: {
			formattedAddress: "Dirección",
			complement: "Complemento",
			postalCode: "Código postal",
			streetName: "Nombre de la calle",
			streetNumber: "Número de la calle",
			neighborhood: "Colonia",
			city: "Ciudad",
			state: "Estado",
			country: "País",
			save: "Guardar información de dirección",
		},
		delivery: {
			attendanceRadius: {
				label: "Radio de atención",
				sufix: "km",
			},
			deliveryFeePerKm: "Tarifa de entrega por Km",
			fixedDeliveryFee: "Tarifa mínima de entrega",
			avgWaitTime: {
				label: "Tiempo promedio de entrega",
				sufix: "Minutos",
			},
			save: "Guardar información de entrega",
		},
		initialInfo: {
			name: "Nombre",
			isManualMenu: "Activación manual de menú",
			isOrganization: "Modo organización",
			save: "Guardar información inicial",
		},
		payments: {
			methods: {
				creditCard: "Tarjeta de crédito",
				debitCard: "Tarjeta de débito",
				cash: "Efectivo",
				creditCardOnline: "Tarjeta de crédito en línea",
				others: "Otras formas de pago",
				voucherInPlace: "Voucher",
				mastercard: "Master-card",
				visa: "Visa",
				amex: "Amex",
				elo: "Elo",
				hipercard: "Hiper-card",
				diners: "Diners",
				ticket: "Ticket",
				alelo: "Alelo",
				vr: "VR",
				ben: "Ben",
				sodexo: "Sodexo",
				pix: "Pix",
			},
			save: "Guardar métodos de pago",
		},
		qrCodeGenerator: {
			columns: {
				url: "URL",
				params: "Parámetro",
				value: "Valor del parámetro",
			},
			warningNotification: "Complete todos los campos.",
			urlRequired: "URL es obligatorio",
			paramsRequired: "Parámetro es obligatorio",
			valueRequired: "Valor del parámetro es obligatorio",
			new: "Nuevo QR code",
			download: "Descargar QR codes",
			import: "Importar QR codes",
			chooseSheet: "Elija una hoja de cálculo",
			sheetFilename: "QR codes",
		},
		webPage: {
			image: "Imagen",
			slug: "Slug",
			primaryColor: "Color Primario",
			secondaryColor: "Color Secundario",
			save: "Guardar información de visualización",
		},
	},
};
